export const ModalType = {
  DELETE: 'DELETE',
  EDIT: 'EDIT',
  REPLY: 'REPLY',
  CREATE_COACH_TASK: 'CREATE_COACH_TASK',
  FLAG: 'FLAG',
  UNFLAG: 'UNFLAG',
  THREAD: 'THREAD',
  SAVE_TO_DOCUMENTS: 'SAVE_TO_DOCUMENTS',
  SHARE_AS_HIGHLIGHT: 'SHARE_AS_HIGHLIGHT',
};
